class SnackbarController {
    title = ""
    message = ""
    snackbar = false
    timeout = 10000
    color = 'red'
    backgroundColor = ''
    icon = 'mdi-check-circle-outline'
    actions = null
    position = null
    isConfirm = false
    context = null

    constructor() {
        this.title = ''
        this.message = ''
        this.snackbar = false
        this.timeout = 10000
        this.color = 'red'
        this.backgroundColor = ''
        this.icon = 'mdi-check-circle-outline'
        this.actions = {
            accept: false,
            cancel: false,
        }
        this.position = {
            right: true,
            center: true,
            top: false,
        }
        this.isConfirm = false
        this.context = null
    }

    show({
        type = 'error',
        icon = '',
        title = '',
        message = '',
        timeout = 10000,
        color = '',
        backgroundColor = '',
        actions = { cancel: false },
        position = {
            right: true,
            center: true,
            top: false,
        },
    }) {
        this.title = title
        this.message = message
        this.timeout = timeout
        this.snackbar = true
        this.color = color
        this.actions = actions
        this.position = position
        this.icon = icon
        this.backgroundColor = backgroundColor

        switch (type) {
            case "success":
                this.icon = 'mdi-check-circle-outline',
                this.color = 'success',
                this.backgroundColor = 'success lighten-1'
                break;
            case "warning":
                this.icon = 'mdi-alert-outline',
                this.color = 'warning',
                this.backgroundColor = 'warning lighten-1'
                break;
            case "error":
                this.icon = 'mdi-close-circle-outline',
                this.color = 'error',
                this.backgroundColor = 'error lighten-1'
                break;
            case "info":
                this.icon = 'mdi-information-outline',
                this.color = 'info',
                this.backgroundColor = 'info lighten-1'
                break;
            default:
                this.icon = 'mdi-close-circle-outline',
                this.color = 'error darken-1',
                this.backgroundColor = 'error lighten-1'
                break;
        }


    }


    /*     show({
            message = '',
            timeout = 10000,
            color = 'red',
            actions = { accept: false },
            position = {
                right: true,
                center: true,
                top: false,
            },
        }) {
            this.message = message
            this.timeout = timeout
            this.snackbar = true
            this.color = color
            this.actions = actions
            this.position = position
        } */

    async confirm({
        message = '',
        timeout = 50000,
        color = 'green',
        actions = { accept: true },
        position = {
            right: true,
            center: false,
            top: true,
        },
    }) {
        this.message = message
        this.timeout = timeout
        this.snackbar = true
        this.color = color
        this.actions = actions
        this.position = position
        let handlerInterval
        const confirm = await new Promise((resolve) => {
            const handlerTimeOut = setTimeout(() => {
                resolve(false)
            }, timeout)
            handlerInterval = setInterval(() => {
                if (this.isConfirm) {
                    this.isConfirm = false
                    clearTimeout(handlerTimeOut)
                    resolve(true)
                }
            }, 500)
        })
        clearInterval(handlerInterval)
        return confirm
    }

    accept() {
        this.isConfirm = true
        this.snackbar = false
    }

}

const snackbar = new SnackbarController()
export { snackbar }